export const ACCESS_TYPE = 'ws'; // ws or sse 标志链接方式
export const APP_KEY = 'MYmTxMmIeMmOsvFxRLaxtgvhdMczNVTYzQhAKKxqiOQQKTsbIHWLDUyqmNjnSGMSBQdXWagtmXQvdSBrmBqgsBTbGYPXUEKhTkLsLEevcGEWgenVlJQOKYxuaDqwGgnk'; // 体验机器人的appkey
export const BOT_ID = '1960540501812076288';



// WEBPACK FOOTER //
// ./src/constants/static.js